<template>
    <div class="bg-white px-3" style="margin: -20px; margin-top: -1rem; margin-bottom: 0 !important">
        <!-- 左边 -->
        <div style="margin: 5px; float: right">
            <el-button size="mini" type="success" @click="openModel">添加院区活动</el-button>
        </div>

        <el-table :data="tableData" border style="width: 100%" v-loading="loadings" :height="height"
            ref="configurationTable">
            <el-table-column prop="name" label="活动名称" show-overflow-tooltip align="center">
            </el-table-column>
            <el-table-column prop="address" label="活动地址" show-overflow-tooltip align="center">
            </el-table-column>
            <el-table-column prop="start_time" label="开始时间" show-overflow-tooltip align="center"></el-table-column>
            <el-table-column prop="end_time" label="截止时间" show-overflow-tooltip align="center"></el-table-column>
            <el-table-column prop="limit_people" label="限制报名人数" show-overflow-tooltip align="center"></el-table-column>
            <el-table-column prop="price" label="报名费" show-overflow-tooltip align="center"></el-table-column>
            <el-table-column prop="content" label="内容" show-overflow-tooltip align="center"></el-table-column>
            <el-table-column label="操作" width="250" align="center">
                <template slot-scope="scope">
                    <el-button @click="handleClick(scope.row)" type="primary" size="mini">编辑</el-button>
                    <!-- <el-button @click="deleteClick(scope.row)" type="danger" size="mini">删除</el-button> -->
                </template>
            </el-table-column>
        </el-table>
        <div style="float: right">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="curPage"
                :page-sizes="[15, 30, 50, 100]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
                :total="count">
            </el-pagination>
        </div>

        <el-dialog :title="names" :visible.sync="dialogVisible" top="20px" :append-to-body="true">
            <el-divider></el-divider>
            <div class="dialog-ibox-content">
                <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="110px" class="demo-ruleForm">
                    <el-form-item label="内容标题">
                        <el-input v-model="ruleForm.name" placeholder="请输入内容" style="width: 50%"></el-input>
                    </el-form-item>
                    <el-form-item label="开始时间">
                        <el-date-picker v-model="ruleForm.start_time" type="date" placeholder="选择日期"
                            value-format="yyyy-MM-dd">
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item label="截止时间">
                        <el-date-picker v-model="ruleForm.end_time" type="date" placeholder="选择日期"
                            value-format="yyyy-MM-dd">
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item label="地址">
                        <el-input v-model="ruleForm.address" placeholder="请输入内容" style="width: 50%"></el-input>
                    </el-form-item>
                    <el-form-item label="限制报名人数">
                        <el-input v-model="ruleForm.limit_people" placeholder="请输入内容" style="width: 50%"></el-input>
                    </el-form-item>
                    <el-form-item label="报名费">
                        <el-input v-model="ruleForm.price" placeholder="请输入内容" style="width: 50%"></el-input>
                    </el-form-item>

                     <el-form-item label="图片">
                        <div>
                            <span v-if="!ruleForm.pic" class="btn btn-light border mr-2" @click="chooseImage">
                                <i class="el-icon-plus"></i>
                            </span>
                            <img v-else :src="ruleForm.pic" class="rounded"
                                style="width: 100px; height: 100px; cursor: pointer" @click="chooseImage" />
                        </div>
                    </el-form-item>
                    <el-form-item label="内容">
                        <WangEditor ref="editor1" @editorContent="changeEditor" :editorContent="ruleForm.content"
                            :operateflag="operateflag" />
                    </el-form-item>
                </el-form>
            </div>
            <el-divider></el-divider>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false" size="small">取 消</el-button>
                <el-button @click="subForm" size="small" type="primary">提交</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    import buttonSearch from "@/components/common/button-search.vue";
    import common from "@/common/mixins/common.js";
    const WangEditor = () => import("@/components/wangEnduit/index");
    export default {
        inject: ["app", "layout"],
        props: ["operateProjectId"],
        mixins: [common],
        components: {
            buttonSearch,
            WangEditor,
        },
        data() {
            return {
                tableData: [],
                loadings: false,
                height: null,
                pageSize: 15,
                curPage: 1,
                count: 0,
                names: "",
                dialogVisible: false,
                ruleForm: {
                    name: "",
                    start_time: "",
                    end_time: "",
                    address: "",
                    limit_people: "",
                    price: "",
                    pic: "",
                    // 富文本
                    content: "",
                    // 默认 是新增
                },
                operateflag: "add",
                rules: {},
                projectId: null,
            };
        },
        computed: {},
        mounted() {
            let that = this;
            // 项目id
            that.ruleForm.project_id = that.operateProjectId;
            that.search();
        },
        methods: {
            search() {
                let that = this;
                axios
                    .post(
                        "/admin/lgProjectActivity/index", {
                            project_id: that.ruleForm.project_id,
                            limit: that.pageSize,
                            page: that.curPage,
                        }, {
                            token: true,
                        }
                    )
                    .then((response) => {
                        that.tableData = response.data.data.data;
                        that.count = response.data.data.total;
                    })
                    .catch((error) => {});
            },
             handleSizeChange(val){
                let that = this
                that.pageSize = val
                that.search()
            },
            handleCurrentChange(val){
                 let that = this
                that.curPage = val
                that.search()
            },

            chooseImage() {
                this.app.chooseImage((res)=>{
					this.ruleForm.pic = res[0].url
				},1)
            },
            openModel() {
                let that = this;
                that.operateflag = "add";
                that.names = "新增";
                that.ruleForm.name = null;
                that.ruleForm.start_time = null;
                that.ruleForm.end_time = null;
                that.ruleForm.address = null;
                that.ruleForm.pic = '';
                that.ruleForm.limit_people = null;
                that.ruleForm.price = null;
                that.ruleForm.content = "";
                that.dialogVisible = true;
            },
            subForm() {
                let that = this;

                let param = {
                    id: 0,
                    project_id: null,
                    name: null,
                    start_time: null,
                    end_time: null,
                    address: null,
                    pic: "",
                    limit_people: null,
                    price: null,
                    content: "",
                };
                param = that.ruleForm;
                if (that.names == "新增") {
                    param.id = 0;
                }
                axios
                    .post("/admin/lgProjectActivity/Madd", param, {
                        token: true,
                    })
                    .then((response) => {
                        if (response.data.code == 200) {
                            that.search();
                            that.dialogVisible = false;
                        }
                    })
                    .catch((error) => {});
            },
            handleClick(row) {
                let that = this;
                that.operateflag = "edit";
                that.names = "编辑";
                that.ruleForm.id = row.id;
                that.ruleForm.project_id = row.project_id;
                that.ruleForm.name = row.name;
                that.ruleForm.start_time = row.start_time;
                that.ruleForm.end_time = row.end_time;
                that.ruleForm.address = row.address;
                          that.ruleForm.pic='';
                if(row.pic !=null){
                let dataPic = Object.values(row.pic);
                that.ruleForm.pic = dataPic;
                }
            
                that.ruleForm.limit_people = row.limit_people?row.limit_people.toString():"";
                that.ruleForm.price = row.price;
                that.ruleForm.content = row.content;
                that.dialogVisible = true;
            },
            deleteClick() {},
            // 富文本编辑器内部变更时回调父组件的方法
            changeEditor(param) {
                let that = this;
                that.ruleForm.content = param;
            },
        },
    };
</script>

<style></style>